// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: '58c0b175-d2e0-4e58-b985-56750fee4551',
      type: 'Sprite',
      runtimeType: null,
      name: 'tileHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'tile_hover',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'a19a8755-542a-45bd-b5c6-77f36ca977f3',
      type: 'Sprite',
      runtimeType: null,
      name: 'iceLayer',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Lock_Layer',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '27cb1c40-34db-467b-8fa8-926626125fed',
      type: 'Sprite',
      runtimeType: null,
      name: 'iceLayerHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Lock_Layer',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      type: 'Container',
      runtimeType: null,
      name: 'shatteredContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      type: 'Container',
      runtimeType: null,
      name: 'lockContainer',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0.8,
        y: 0.8
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'aeca96d2-0f92-47a0-bf33-aae7a6913c20',
      type: 'Text',
      runtimeType: null,
      name: 'scoreText',
      className: '',
      x: 0,
      y: -41,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '250',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6643e5ef-1d68-4bcb-aef3-f4207369b2b4',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -39,
      y: -44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_1',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '4d52c295-30b9-4a95-9a6f-4403bc53c33d',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 7,
      y: -36,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_2',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '39193e60-7dde-4289-b9fc-cbaf9157a656',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 35,
      y: -36,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_3',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3686726a-476a-4830-a458-34d5ae2457e7',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 49,
      y: 6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_4',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '4cd04d00-7413-401a-b288-34582d4cc168',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 49,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_5',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'eaf15462-5ab2-4734-964f-490cbaadb499',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -14,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_6',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '627fd255-2a97-4f69-9862-3393fde1547c',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -47,
      y: 30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_7',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '9cbc1930-55af-4956-8b16-f44093a3d60f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: -47,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Ice_Fragment_8',
      parent: '72dc7867-35b8-4e95-b209-676ecf5369ee',
      data: undefined,
      stateByName: {}
    },
    {
      id: '3f30208e-906d-4d59-a158-f0b53642b942',
      type: 'Container',
      runtimeType: null,
      name: 'lockHook',
      className: '',
      x: 0,
      y: 35,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      type: 'Container',
      runtimeType: null,
      name: 'lockBody',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4dd56ce7-997a-4126-9120-3bf82c7900f3',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'cbf7282b-5d5d-4f44-89dc-9c75433407cb',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Hook',
      parent: '3f30208e-906d-4d59-a158-f0b53642b942',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'f69f9bff-5814-4b61-bf12-68d67760776f',
      type: 'Sprite',
      runtimeType: null,
      name: 'lockHookHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock_Hook',
      parent: '3f30208e-906d-4d59-a158-f0b53642b942',
      data: undefined,
      stateByName: {}
    },
    {
      id: 'fe301b7d-4ecb-446e-99b0-53b564f44ee4',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock',
      parent: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      data: undefined,
      stateByName: {}
    },
    {
      id: '6eae3ed4-1bbb-4b5b-acfe-b08acec6c3dc',
      type: 'Sprite',
      runtimeType: null,
      name: 'lockBodyHighlight',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Lock',
      parent: '6971f82a-b71e-45f4-bb7c-9c92bfe96f92',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [],
  animations: []
} as const;

export class ScoreBlockerLayout {
  static raw = raw;
  root: Container;
  tileHighlight: Sprite;
  iceLayer: Sprite;
  iceLayerHighlight: Sprite;
  shatteredContainer: Container;
  lockContainer: Container;
  scoreText: Text;
  lockHook: Container;
  lockBody: Container;
  lockHookHighlight: Sprite;
  lockBodyHighlight: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: typeof raw['list'][0];
      tileHighlight: typeof raw['list'][1];
      iceLayer: typeof raw['list'][2];
      iceLayerHighlight: typeof raw['list'][3];
      shatteredContainer: typeof raw['list'][4];
      lockContainer: typeof raw['list'][5];
      scoreText: typeof raw['list'][6];
      lockHook: typeof raw['list'][15];
      lockBody: typeof raw['list'][16];
      lockHookHighlight: typeof raw['list'][18];
      lockBodyHighlight: typeof raw['list'][20];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
